// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"History_wrapper__DQtRS","emptyPrompt":"History_emptyPrompt__4w_rS","listWrapper":"History_listWrapper__NnNVS"};